// Externals
import React, { useContext } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { getDynamicUrl } from '../../middleware/lokaliseUrlMiddleware';

// Components
import { NavigationBar as NavigationBarComponent } from '@homeexchange/navigation-bar';

// Context
import { withCurrency } from '../currency';
import { GeoIPContext } from '../geoip/GeoIPProvider';

const NavigationBar = (props) => {
    const {
        localeDescription,
        session,
        initialData,
        theme,
        variant,
        isImpersonating,
        overlay,
        pageSearchBarSelector,
        background,
        memberSearchBar
    } = props;
    const { geoipLocal } = useContext(GeoIPContext);

    return (
        <NavigationBarComponent
            config={{
                apiUrl: getDynamicUrl(process.env.URL_BFF),
                assetsUrl: process.env.URL_MIGRATION_ASSETS,
                jawgToken: process.env.JAWG_KEY,
                jawgUrl: process.env.URL_JAWG_URL,
                geoipLocal
            }}
            variant={variant}
            session={session}
            initialData={initialData}
            theme={theme}
            locale={localeDescription}
            isImpersonating={isImpersonating}
            overlay={overlay}
            pageSearchBarSelector={pageSearchBarSelector}
            background={background}
            memberSearchBar={memberSearchBar}
        />
    );
};

NavigationBar.propTypes = {
    localeDescription: PropTypes.string,
    session: PropTypes.shape({
        status: PropTypes.oneOf(['anonymous', 'authenticated']).isRequired,
        user: PropTypes.shape({
            id: PropTypes.number.isRequired,
            firstName: PropTypes.string,
            isCollection: PropTypes.bool
        })
    }).isRequired,
    initialData: PropTypes.shape({
        account: PropTypes.object,
        guestpoints: PropTypes.object,
        messages: PropTypes.object
    }),
    theme: PropTypes.oneOf(['regular', 'collection']),
    variant: PropTypes.oneOf(['full', 'lite']),
    isImpersonating: PropTypes.bool,
    overlay: PropTypes.bool,
    pageSearchBarSelector: PropTypes.string,
    background: PropTypes.oneOf(['white', 'tinted']),
    memberSearchBar: PropTypes.node
};

NavigationBar.defaultProps = {
    initialData: undefined,
    theme: 'regular',
    variant: 'full',
    isImpersonating: false,
    overlay: false,
    pageSearchBarSelector: undefined,
    background: 'white',
    memberSearchBar: undefined
};

const mapStateToProps = (state) => ({
    localeDescription: state.localeDescription
});

export default compose(connect(mapStateToProps), withCurrency)(NavigationBar);
